import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ReactComponent as EmailIcon } from 'src/assets/email.svg';
import { ReactComponent as FlipBackward } from 'src/assets/tailwind/flip-backward.svg';
import { Button } from 'src/components/ui/button';
import { Typography } from 'src/components/ui/typography';
import { LANDING_PAGE } from 'src/utils/constants';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

import { InfoContainer } from '../../InfoContainer';

type VerifyEmailProps = {
  loading: boolean;
  email: string;
  onResend: () => void;
  onChangeEmail: () => void;
};

export const VerifyEmail = ({
  loading,
  email,
  onResend,
  onChangeEmail
}: VerifyEmailProps) => {
  const { t } = useTranslation();
  return (
    <div className="tw:w-full tw:max-w-116 tw:min-h-103 tw:rounded-xl tw:bg-primary tw:p-4 sm:tw:p-6 md:tw:p-10 tw:gap-6 sm:tw:gap-8 md:tw:gap-10 tw:flex tw:flex-col tw:mx-4 sm:tw:mx-0 tw:mt-10 sm:tw:mt-0">
      {/* Header */}
      <div className="tw:gap-1 tw:text-center">
        <Typography className="tw:font-['Lato'] tw:text-3xl  tw:text-text-primary tw:text-center tw:font-bold sm:tw:text-2xl md:tw:text-3xl tw:tracking-normal">
          {t(T.verifyEmail)}
        </Typography>
        <Typography className="tw:text-text-secondary tw:text-center tw:font-['Lato'] tw:text-[14px] tw:font-normal tw:leading-5 tw:tracking-[0]">
          {t(T.sentEmailMessage)} {email}
        </Typography>
      </div>

      {/* Body */}
      <div className="tw:text-center">
        <Typography className="tw:text-text-secondary tw:text-center tw:font-['Lato'] tw:text-[14px] tw:font-normal tw:leading-5 tw:tracking-[0]">
          <Trans
            i18nKey={T.verificationEmailMessage}
            components={{
              span: <span className="tw:text-text-primary tw:cursor-pointer" />
            }}
          />
        </Typography>
      </div>

      {/* Buttons */}
      <div className="tw:flex tw:flex-col tw:gap-3 sm:tw:gap-4">
        <Button
          leftIcon={EmailIcon}
          hierarchy="primary"
          className="tw:w-full tw:hover:cursor-pointer tw:text-sm sm:tw:text-base"
          text={t(T.resendVerificationEmail)}
          onClick={() => onResend()}
          loading={loading}
          disabled={loading}
        />

        <Button
          leftIcon={FlipBackward}
          hierarchy="secondary"
          className="tw:w-full tw:hover:cursor-pointer tw:text-sm sm:tw:text-base"
          text={t(T.changeEmail)}
          onClick={onChangeEmail}
          disabled={loading}
        />
      </div>

      <div className="tw:text-text-secondary tw:text-center tw:font-['Lato'] tw:text-[14px] tw:font-normal tw:leading-5 tw:tracking-[0]">
        <span>
          {t(T.alreadyHaveAccount)}
          <Link
            to={LANDING_PAGE}
            className="tw:text-brand tw:font-medium tw:ml-1 hover:tw:opacity-90"
          >
            {t(T.signIn)}
          </Link>
        </span>
      </div>

      {/* Support */}
      <div className="tw:items-center tw:justify-center">
        <InfoContainer />
      </div>
    </div>
  );
};
